<template>
  <div class="error flexcenter">
    <transition>
      <div class="err flexcenter">
        <div v-if="buttonKind === 'login'">
          <div v-if="isEnvironmentPc()">
            <p>再度サインインしてください。</p>
            <p>改善しない場合は、<a href="https://www.sourcenext.com/support/qa/?faq=RS-09396" target="_blank">サポートページ</a>をご覧ください。</p>
          </div>
          <div v-else>再度サインインしてください</div>
        </div>
        <div v-else>
          <div>{{ message }}</div>
        </div>

        <!-- ログイン -->
        <div class="align-center" v-if="buttonKind === 'login'">
          <button class="login" type="button" @click="goLogin">サインインする</button>
        </div>
        <!-- 辞書画面で入力値エラー -->
        <div class="align-center" v-if="buttonKind === ''">
          <button class="login" type="button" @click="$emit('close')">OK</button>
        </div>
      </div><!-- err flexcenter -->
    </transition>
  </div><!-- error flexcenter -->
</template>

<script>
import common from '@/mixin/common';

export default {
  name: 'error',
  props: {
    message: String,
    buttonKind: String,
    routeQuery: Object,
    platformName: String,
  },
  mixins: [
    common,
  ],
  created: function () {
    this.log("Error start created");
    this.log("message: " + this.message);
    this.log("buttonKind: " + this.buttonKind);
  },
  mounted: function () {
    this.log("Error start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false);
  },
  methods: {
    /**
     * ログイン画面へ遷移
     */
    goLogin: function () {
      if (this.isDocomo(this.platformName)) {
        // ドコモ認証を行う
        window.Phone.DoAuth();
      } else {
        // ログイン画面へ遷移
        var route = { name: 'Login' };
        if (this.routeQuery) {
          route.query = this.routeQuery;
        }
        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// Error.vue?7b225a0b